
import { Line } from "vue-chartjs";
import { emptyLabels, partografYAxis, partografXAxes, partografLayout } from "./partografAxis";

export default {
  extends: Line,
  props: {
    dataSet: [],
    td: [],
  },
  data() {
    return {
      labels: emptyLabels(),
      chartData: null,
      options: {
        scales: {
          yAxes: [
            partografYAxis({
              suggestedMin: 60,
              suggestedMax: 180,
              stepSize: 10,
            }),
          ],
          xAxes: partografXAxes(),
        },
        layout: partografLayout(),
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  methods: {
    buildChartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: "Nadi",
            data: this.dataSet,
            pointStyle: "dot",
            pointRadius: 5,
            borderWidth: 2,
            spanGaps: true,
            tension: 0,
            fill: false,
            borderColor: "Red",
            backgroundColor: "Red",
          },
          {
            label: "Tekanan Darah",
            data: this.td,
            borderWidth: 1,
            barThickness: 5,
            type: "bar",
            backgroundColor: "blue",
          },
        ],
      };
    },
    redraw() {
      this.chartData = this.buildChartData();
      this.renderChart(this.chartData, this.options);
    },
  },
  mounted() {
    this.redraw();
  },
  watch: {
    dataSet: function () {
      this.redraw();
    },
    td: function () {
      this.redraw();
    },
  },
};
